export default ({ strings }) => ({
    visible: true,
    blog: {
        visible: true,
        destination: "http://educationblog.rosettastone.com/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
        visible: true,
        destination: "/resources/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
        visible: true,
        destination: "/solutions/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_primary_solutions_label,
        options: [
            {
                link: "/solutions/k12-english-language/",
                label: strings.nav_secondary_education_primary_solutions_k12_english_language
            },
            {
                link: "/solutions/world-languages/",
                label: strings.nav_secondary_education_primary_solutions_world_languages
            }
        ]
    },
    vertical_header: {
        visible: true,
        destination: "/",
        external: false,
        new_window: false,

        // Labels
        label: strings.nav_secondary_education_primary_label
    }
});
